import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold text-[#16161d] text-left" }, "Plantões inclusos", -1)
const _hoisted_3 = { class: "w-full overflow-x-auto border border-[#d8d8e2] rounded-lg" }
const _hoisted_4 = { class: "w-full min-w-[600px] border-collapse" }
const _hoisted_5 = { class: "bg-[#f0f0f4]" }
const _hoisted_6 = { class: "px-4 py-2.5 text-center text-[13px] text-[#16161d]" }
const _hoisted_7 = {
  class: "px-4 py-2.5 text-center text-[13px] text-[#16161d]",
  "data-testid": "station-time-range-cell"
}
const _hoisted_8 = { class: "px-4 py-2.5 text-center text-[13px] text-[#16161d]" }
const _hoisted_9 = { class: "px-4 py-2.5 text-center text-[13px] text-[#16161d]" }
const _hoisted_10 = { class: "px-4 py-2.5 text-center text-[13px] text-[#16161d]" }
const _hoisted_11 = { class: "px-4 py-2.5 text-center text-[13px] text-[#16161d]" }

import { computed } from 'vue'
import { format, parseISO } from 'date-fns'
import { StationSummary } from '@/Network/Types/Responses/HandoverInviteResponses'
import { PackageRecurrence } from '@/Network/Types/Requests/HandoverInviteRequests'
import { formatCurrency } from '@/utils/formatters'
import { formatHourMinuteInOffset } from '@/utils/date'

const DEFAULT_STATION_UTC_OFFSET = '-03:00'


export default /*#__PURE__*/_defineComponent({
  __name: 'StationsTable',
  props: {
    stations: {},
    recurrence: {}
  },
  setup(__props: any) {

const props = __props;



const RECURRENCE_LABELS: Record<string, string> = {
  SINGLE: 'Único',
  WEEKLY: 'Semanal',
  BIWEEKLY: 'Quinzenal',
  MONTHLY_ABCDE: 'Mensal ABCDE'
}

const columns = ['Data', 'Horário', 'Posição', 'Turno', 'Recorrência', 'Valor']

const recurrenceLabel = computed(() => RECURRENCE_LABELS[props.recurrence] ?? props.recurrence)

const formatStationDate = (dateStr: string) => {
  try {
    return format(parseISO(dateStr), 'dd/MM/yyyy')
  } catch {
    return dateStr
  }
}

const formatStationTimeRange = (
  startTime?: string | null,
  endTime?: string | null,
  timezone?: string | null
) => {
  if (!startTime || !endTime) return '-'

  const offset = timezone ?? DEFAULT_STATION_UTC_OFFSET
  const start = formatHourMinuteInOffset(startTime, offset)
  const end = formatHourMinuteInOffset(endTime, offset)
  if (!start || !end) return '-'

  return `${start} às ${end}`
}

const formatValue = (value?: number | null) => {
  if (value === null || value === undefined) return '-'
  return formatCurrency(value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
              return _createElementVNode("th", {
                key: col,
                class: "px-4 py-2.5 text-sm font-bold text-[#272735] text-center"
              }, _toDisplayString(col), 1)
            }), 64))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stations, (station) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: station.id,
              class: "border-t border-[#e8e8ed] bg-white"
            }, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(formatStationDate(station.date)), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(formatStationTimeRange(station.startTime, station.endTime, station.timezone)), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(station.position ?? '-'), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(station.type ?? '-'), 1),
              _createElementVNode("td", _hoisted_10, _toDisplayString(recurrenceLabel.value), 1),
              _createElementVNode("td", _hoisted_11, _toDisplayString(formatValue(station.value)), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})